import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { CircularProgress, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  getOrderDataAnalytics,
  getOrderStatusAnalytics,
  getSales,
  getProposalData,
} from '../../Services/DashboardApi';
import { dashboardItemsSelector } from '../../redux/dashboard';
import WeeklyImageModal from '../../Components/Modals/WeeklyImageModal';
import OrderStatus from '../../Components/chart/orderStatus';
import OrderData from '../../Components/chart/orderData';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Sales from '../../Components/chart/sales';
import CustomBox from '../../Components/CommonComp/CustomBox/CustomBox';
import Proposal from '../../Components/chart/proposal';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: (theme.vars ?? theme).palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

function Dashboard1({
  weeklyImageModal = false,
  handleWeeklyImageModal = () => false,
}) {
  const dispatch = useDispatch();
  const state = useSelector(dashboardItemsSelector);
  const isLoading = state?.chartData?.orderStatusAnalytics?.isLoading;

  const getChartData = async (params = {}) => {
    dispatch(getOrderStatusAnalytics());
    dispatch(getOrderDataAnalytics());
    dispatch(getSales());
    dispatch(getProposalData());
  };

  useEffect(() => {
    getChartData();
  }, []);

  return (
    <Box
      component="main"
      sx={(theme) => {
        return {
          flexGrow: 1,
          // bgcolor: theme.backgroundColor.box.main,
          // p: 4,
          // pl: 0,
        };
      }}
    >
      <>
        {isLoading ? (
          <CircularProgress color="inherit" size={20} />
        ) : (
          <Grid container spacing={4}>
            <Grid item xs={4} lg={4} md={4}>
              <CustomBox padding={2}>
                <OrderStatus />
              </CustomBox>
            </Grid>
            <Grid item xs={8} lg={8} md={8}>
              <CustomBox padding={2} style={{ marginVertical: 5 }}>
                <Sales />
              </CustomBox>
            </Grid>
            <Grid item xs={6} lg={6} md={6}>
              <CustomBox padding={2} marginBottom={20}>
                <OrderData />
              </CustomBox>
            </Grid>
            <Grid item xs={6} lg={6} md={6}>
              <CustomBox padding={2} marginBottom={20}>
                <Proposal />
              </CustomBox>
            </Grid>
            {/* <Grid item xs={12} md={12} lg={12}>
              <CustomBox padding={2}>
                <OrderData />
              </CustomBox>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <CustomBox padding={2} marginBottom={20}>
                <Proposal />
              </CustomBox>
            </Grid> */}
          </Grid>
        )}
      </>
      <WeeklyImageModal
        open={weeklyImageModal}
        handleOpen={handleWeeklyImageModal}
      />
    </Box>
  );
}

export default Dashboard1;